import React from 'react';
import finishTheme from '../../sound/improvimania/finish.m4a';
import AudioPlayer from '../AudioPlayer';
import './PlayerScreen.css';

const PlayerScreen = ({
  isEndGame,
  sessionId,
  playerName,
  gameStarted,
  players,
  playerRole,
  isEndScene,
  currentLine,
  isSpeaker,
  nextLine,
  guessAdlibber,
  voteAdlibLine,
  leaderboard,
  sentGuess,
  isMusicMuted,
  gameMode,
  activeVote,
  voteBudgetRemaining,
  votedLineIds,
}) => {
  const myPositiveVotes = voteBudgetRemaining?.[playerName] || 0;
  const hasVotedCurrentLine = Boolean(activeVote?.lineId && votedLineIds?.[activeVote.lineId]);
  const canVoteCurrentLine =
    gameMode === 'linejudge' &&
    activeVote &&
    activeVote.speakerName !== playerName &&
    !hasVotedCurrentLine;

  const renderLineJudgeControls = () => {
    if (gameMode !== 'linejudge') return null;

    return (
      <div className="improv-player-actions">
        <p className="improv-player-copy">
          Positive votes left this game: <b>{myPositiveVotes}</b>
        </p>
        {activeVote && (
          <p className="smalltext">
            Voting now: {activeVote.speakerName}
          </p>
        )}
        {canVoteCurrentLine && (
          <>
            <button
              disabled={myPositiveVotes <= 0}
              onClick={() => voteAdlibLine(activeVote.lineId, 1)}
            >
              +1 Give Point
            </button>
            <button onClick={() => voteAdlibLine(activeVote.lineId, -1)}>
              -1 Remove Point
            </button>
          </>
        )}
        {activeVote && !canVoteCurrentLine && (
          <p className="smalltext">
            {activeVote.speakerName === playerName
              ? 'You cannot vote on your own adlib line.'
              : hasVotedCurrentLine
                ? 'Vote submitted for this line.'
                : 'Waiting for the next adlib line to vote on.'}
          </p>
        )}
      </div>
    );
  };

  const renderLobby = () => (
    <div className="improv-player-card">
      <h3>Welcome, {playerName}</h3>
      <h2>Joined Session: {sessionId}</h2>
      <h4>Players:</h4>
      <ul className="improv-player-list">
        {players.map((player, index) => (
          <li key={index}>{player.name}</li>
        ))}
      </ul>
      <p>
        {players.length === 4
          ? 'Waiting for host to start the game...'
          : 'Waiting for 4 players...'}
      </p>
    </div>
  );

  const renderRoleCard = (roleLabel) => (
    <div className="improv-player-card">
      <h3>Your Role: {roleLabel}</h3>
      {isEndScene ? (
        <div className="improv-player-copy">
          {roleLabel === 'Guesser'
            ? 'Choose the person you think was making up their lines.'
            : 'END SCENE'}
        </div>
      ) : (
        <>
          {roleLabel === 'Speaker' && isSpeaker && (
            <div className="improv-player-copy">Read your line:</div>
          )}
          <div className="improv-player-copy">
            <b>{currentLine?.text}</b>
          </div>
          {currentLine?.isAdlib && <p className="smalltext">(It's your line!)</p>}
          {isSpeaker && <button onClick={nextLine}>Next</button>}
          {renderLineJudgeControls()}
        </>
      )}
    </div>
  );

  const renderGuesserCard = () => (
    <div className="improv-player-card">
      <h3>Your Role: Guesser</h3>
      {isEndScene ? (
        <>
          <p className="improv-player-copy">Choose the person you think was making up their lines:</p>
          {!sentGuess && (
            <div className="improv-player-actions">
              {players.map((player, index) => (
                player.name !== playerName && (
                  <button key={index} onClick={() => guessAdlibber(player.name)}>
                    {player.name}
                  </button>
                )
              ))}
            </div>
          )}
          {sentGuess && <p className="smalltext">Your guess was sent.</p>}
        </>
      ) : (
        <>
          <p className="improv-player-copy">Listen carefully and try to guess the adlibber!</p>
          <b>{currentLine?.text}</b>
          {renderLineJudgeControls()}
        </>
      )}
    </div>
  );

  return (
    <div className="improv-player-shell">
      {!isEndGame ? (
        <>
          {!gameStarted ? (
            renderLobby()
          ) : (
            <>
              {playerRole && playerRole.startsWith('Speaker 1') && renderRoleCard('Adlibber')}
              {playerRole && (playerRole.startsWith('Speaker 2') || playerRole.startsWith('Speaker 3')) && renderRoleCard('Speaker')}
              {playerRole === 'Guesser' && renderGuesserCard()}
            </>
          )}
        </>
      ) : (
        <div className="improv-player-card">
          <AudioPlayer audioSrc={finishTheme} isMuted={isMusicMuted} />
          <h3>Game Results</h3>
          <ul className="improv-player-list">
            {Object.entries(leaderboard).map(([name, score]) => (
              <li key={name}>
                {name}: {score}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default PlayerScreen;
